import { Col, Row } from "react-bootstrap";
import NavigationBar from "../NavigationBar/NavigationBarComponent";
import { Box, Button, IconButton, TextField, Tooltip } from "@mui/material";
import { useState } from "react";

import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { useSnackbar } from "../Common/SnackbarContext";
import { getDecryptedUrl } from "../../api/decryptUrlApi/decryptUrlApi";

const DecryptURL = () => {
  const [encryptedURL, setEncryptedURL] = useState("");
  const [decryptedValue, setDecryptedValue] = useState<any>();
  const { showSnackbar } = useSnackbar();
  const [isVisible, setIsVisible] = useState(false);

  const handleClear = () => {
    setEncryptedURL("");
    setDecryptedValue("");
    setIsVisible(false);
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.value.length > 0) {
      setEncryptedURL(e.target.value);
    } else {
      setEncryptedURL("");
    }
  };

  const handleDecrypt = () => {
    if (encryptedURL === "") {
      showSnackbar("Please enter a valid URL to decrypt", true);
      return;
    } else {
      getDecryptedUrlData(encryptedURL);
    }
  };

  const getDecryptedUrlData = async (url: string) => {
    try {
      const urlObj = new URL(url);
      const hasInfoParam = urlObj.searchParams.has("info");
      const hasInfoInPath = url.toLowerCase().includes("info");

      if (!hasInfoParam && !hasInfoInPath) {
        showSnackbar(
          "URL must contain 'info' parameter or 'info' in the path",
          true,
        );
        return;
      }
    } catch (error) {
      showSnackbar("Please enter a valid URL format", true);
      return;
    }

    // Call API to get decrypted URL - handle all responses
    try {
      const response = await getDecryptedUrl({ url });
      if (response && response.success) {
        setIsVisible(true);
        setDecryptedValue(response);
      } else {
        setIsVisible(false);
        setDecryptedValue(response);
      }
    } catch (error: any) {
      setIsVisible(false);
      console.error("API Error:", error);
      // If the error has a response body, show that
      if (error.response?.data) {
        setDecryptedValue(error.response.data);
      } else if (error.message) {
        setDecryptedValue({ error: error.message });
      } else {
        setDecryptedValue({ error: "An unknown error occurred" });
      }
    }
  };

  const handleCopyToClipboard = () => {
    if (decryptedValue) {
      navigator.clipboard.writeText(JSON.stringify(decryptedValue, null, 2));
      showSnackbar("Response copied to clipboard");
    }
  };

  return (
    <div>
      <NavigationBar
        menuTitle="Configuration"
        title="Decrypt URL"
        text="Decrypt URL"
      />
      <Row style={{ margin: "2em" }}>
        <Col xs={12}>
          <Box>
            <div className="rp-main-inner col-sm-12">
              <div
                className="queue-top row clearfix"
                style={{ marginTop: "-.5em" }}
              >
                <div
                  className="col-sm-12"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--aggrid-text-color)",
                    fontWeight: 600,
                    fontSize: "11px",
                    gap: "1em",
                  }}
                >
                  {" "}
                  <div className="col-sm-1">Enter URL to Decrypt : </div>
                  <div className="col-sm-9">
                    <input
                      type="text"
                      placeholder="Decrypt URL"
                      value={encryptedURL}
                      onChange={handleSearchChange}
                      className="searchInput"
                      style={{
                        width: "55%",
                        height: "2.25em",
                        padding: "0.5em",
                        border: "2px solid #ccc",
                      }}
                    />
                  </div>
                </div>
                <div
                  className="col-sm-12"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--aggrid-text-color)",
                    fontWeight: 600,
                    fontSize: "11px",
                    gap: "1em",
                    marginTop: "1em",
                  }}
                >
                  <div className="col-sm-1"></div>
                  <div className="col-sm-9">
                    {" "}
                    <Button
                      variant="contained"
                      size="small"
                      className="button ok-button"
                      onClick={handleDecrypt}
                    >
                      Decrypt
                    </Button>
                    <Button
                      variant="contained"
                      size="small"
                      className="button clear-button"
                      onClick={handleClear}
                    >
                      Clear
                    </Button>
                  </div>
                </div>

                <div
                  className="col-sm-12"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--aggrid-text-color)",
                    fontWeight: 600,
                    fontSize: "11px",
                    gap: "1em",
                    marginTop: "3em",
                  }}
                >
                  {" "}
                  <div
                    className="col-sm-1"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      textAlign: "center",
                    }}
                  >
                    Response :{" "}
                  </div>
                  <div
                    className="col-sm-9"
                    style={{
                      display: "flex",
                      justifyContent: "left",
                      alignItems: "flex-start",
                      marginTop: "20px",
                      height: "100px",
                    }}
                  >
                    <TextField
                      multiline
                      aria-label="minimum height"
                      maxRows={50}
                      style={{
                        width: "55%",
                        overflow: "auto",
                        padding: "0.5em",
                        marginLeft: "-.5em",
                      }}
                      value={decryptedValue && decryptedValue !== "" ? JSON.stringify(decryptedValue, null, 2) : ""}
                      InputProps={{
                        readOnly: true,
                        style: {
                          backgroundColor: "white",
                          border: "1px solid #ccc",
                          font: "menu",
                          fontFamily: "monospace",
                        },
                      }}
                    />
                    {isVisible && (
                      <Tooltip title="Copy content to clipboard">
                        <IconButton
                          className="icon-button"
                          style={{ padding: ".1vh", marginTop: "1em" }}
                          onClick={() => handleCopyToClipboard()}
                        >
                          <ContentCopyIcon />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </Col>
      </Row>
    </div>
  );
};

export default DecryptURL;